import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const WordPressLogo = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M0.398682 10.6199C0.398682 14.8237 2.97116 18.4565 6.70146 20.1781L1.3669 6.29779C0.746389 7.6186 0.398682 9.08027 0.398682 10.6199Z"
          fill={color}
        />
        <path
          d="M19.1314 10.0839C19.1314 8.7714 18.635 7.86243 18.2092 7.15494C17.6423 6.28013 17.1109 5.53929 17.1109 4.66447C17.1109 3.68821 17.8906 2.77945 18.9888 2.77945C19.0384 2.77945 19.0855 2.78531 19.1338 2.78793C17.1441 1.05689 14.4933 0 11.5819 0C7.67495 0 4.23767 1.90362 2.23804 4.78694C2.50041 4.79441 2.74768 4.79967 2.95771 4.79967C4.12744 4.79967 5.93812 4.66488 5.93812 4.66488C6.54097 4.63113 6.61204 5.472 6.00983 5.53969C6.00983 5.53969 5.404 5.60739 4.72987 5.64094L8.80234 17.1445L11.2497 10.1741L9.50733 5.64053C8.90512 5.60699 8.33462 5.53929 8.33462 5.53929C7.73198 5.50575 7.80263 4.63073 8.40526 4.66447C8.40526 4.66447 10.2521 4.79926 11.351 4.79926C12.5205 4.79926 14.3314 4.66447 14.3314 4.66447C14.9347 4.63073 15.0055 5.47159 14.4031 5.53929C14.4031 5.53929 13.796 5.60699 13.1231 5.64053L17.1645 17.057L18.28 13.5171C18.7635 12.0482 19.1314 10.9931 19.1314 10.0839Z"
          fill={color}
        />
        <path
          d="M11.7782 11.5488L8.42285 20.808C9.42469 21.0877 10.4842 21.2407 11.582 21.2407C12.8843 21.2407 14.1332 21.0269 15.2957 20.6387C15.2657 20.5932 15.2385 20.5449 15.2161 20.4923L11.7782 11.5488Z"
          fill={color}
        />
        <path
          d="M21.3946 5.52448C21.4427 5.86276 21.4699 6.2259 21.4699 6.61653C21.4699 7.69424 21.258 8.90572 20.6196 10.4205L17.2036 19.7998C20.5283 17.9586 22.7646 14.538 22.7646 10.62C22.7648 8.77356 22.2681 7.03727 21.3946 5.52448Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default WordPressLogo
